<template>
    <div class=" marginL201 clearfix" style="overflow: auto;">
        <div class="yh-title" style="position:relative;">
            <img src="../../../images/yhkh.png" alt="" style="margin-top:10px;margin-left:30px;">
            <span @click="getBack" style="position:absolute;cursor:pointer;right:20%;top:10px;color:#00b2b1;font-size: 16px;">返回上一步</span>
        </div>
        <div class="yhinfo-cons">
            <el-form  label-width="80px" >
                <el-form-item label="持卡人:" style="height:30px;margin-left:17px;">
                    <span>{{docName}}</span>
                </el-form-item>
                <el-form-item label="银行卡号:" style="height:30px;width:35%;margin-left:17px;">
                    <el-input v-model="bankAccount"></el-input>
                </el-form-item>
                <el-form-item label="发卡银行:" style="height:30px;width:35%;margin-left:17px;">
                    <el-select v-model="bankName" >
                        <el-option v-for="item in banklist" :label="item.dicValue" :value="item.dicValue" :key="item.dicValue"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户支行:" style="height:30px;width:35%;margin-left:17px;">
                    <el-input v-model="bankDeposit"><span>请</span></el-input>
                </el-form-item>
                <div class="yhinfo-con">
                    <p>1.该卡用于收入的提现，推荐使用中国工商银行;</p>
                    <p>2.收入平台按月结算，每月20号结算;</p>
                    <p>3.收入金额超过500才能提现，少于500则自动积累到下月;</p>
                    <p>4.为了配合税务要求，需要上传您的身份证件正反面照片。</p>
                </div>
                 <span style="font-size: 14px;color: #48576a;margin-left:10px;margin-top:20px;">身份证示例:</span>
                <div class="backAvater">
                    <div class="bankleft">
                       <div style="height:120px;width:100%;">
                           <img src="../../../images/yinhanga.png" alt="" style="margin-left:120px;">
                       </div>
                        <div style="height:20px;text-align: center;">
                           <span>正面</span>
                        </div>
                        <div style="height:120px;width:100%;margin-top:20px;">
                            <img src="../../../images/yinhangb.png" alt="" style="margin-left:120px;">
                        </div>
                        <div style="height:20px;text-align: center;">
                            <span>反面</span>
                        </div>
                    </div>
                    <div class="bankleft">
                        <el-upload
                                :action="uploadUrl"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :data="uploadData"
                                accept="image/gif,image/jpg,image/jpeg,image/png,image/bmp"
                                :headers={sign:PasWord()}
                                :before-upload="beforeUpload"
                                :on-success="onSuccessImg">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div style="height:20px;width:180px;text-align: center;">
                            <span>正面</span>
                        </div>
                        <el-upload
                                :action="uploadUrl"
                                class="avatar-uploader"
                                :data="uploadData1"
                                style="margin-top:20px;"
                                :show-file-list="false"
                                accept="image/gif,image/jpg,image/jpeg,image/png,image/bmp"
                                :headers={sign:PasWord()}
                                :before-upload="beforeUpload1"
                                :on-success="onSuccessImg1">
                            <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div style="height:20px;width:180px;text-align: center;">
                            <span>反面</span>
                        </div>
                    </div>
                </div>
                <p style=" font-size: 14px;line-height: 26px;color:#A4A4A4;margin-left:250px;">请您上传身份证正面照和背面照</p>
                <el-button type="primary"  class=" blue-btn h36 w200"  style="margin-left:20%;margin-top:20px;" @click="setCard">
                    保存
                </el-button>
            </el-form>
        </div>
    </div>
</template>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
<script>
    import Vue from  "vue";
    import { Form, FormItem,Button, Select, Option, DatePicker,Input, Message,MessageBox } from "element-ui";
    import { upLoadBasicParam }from "../../data/basicParam";
    import axiosUtil from "../../utils/AxiosUtils.js";
    import { API_URL } from "../../data/Url";
    export default{
        data(){
            return {
                bankAccount: "",
                bankName: "中国工商银行",
                bankDeposit: "",
                docName: JSON.parse(sessionStorage.getItem("loginInfo")).docName,
                dialogImageUrl: '',
                dialogVisible: false,
                uploadUrl: API_URL,
                imgUploadList: [],
                imgUploadList1: [],
                attaIdList: [],
                uploadData: {},
                uploadData1: {},
                docIdcardA: JSON.parse(localStorage.getItem("docIdcardA")) || {},
                docIdcardB: JSON.parse(localStorage.getItem("docIdcardB")) || {},
                docIdcardUrlA: "",
                docIdcardUrlB: "",
                banklist: [],
                imageUrl:"",
                imageUrl1:"",
                bankAid:"",
                bankBid:"",
                docIdcardAId:"",
                docIdcardBId:""
            }
        },
        computed:{
            upLoadList:function(){
                return this.imgUploadList;
            },
            upLoadList1:function(){
                return this.imgUploadList1;
            }
        },
        mounted:function(){
            let _this=this;
            _this.getBankName();

            let user=JSON.parse(sessionStorage.getItem("loginInfo"))

            _this.imageUrl=_this.docIdcardA.url;
            _this.imageUrl1=_this.docIdcardB.url;
            if(user.bankName=="中国工商银行"){
                this.bankName=user.bankName;
                this.bankAccount=user.bankAccount;
                this.bankDeposit=user.bankDeposit;
            }else{
                this.bankName="";
                this.bankAccount="";
                this.bankDeposit="";
            }
        },

        methods: {
            getBankName:function(){
                let _this=this;
              let options={
                  dicName:"医生提现银行",
                  Service:"nethos.system.dictionary.list",
                  token: localStorage.getItem("token"),
              }
              axiosUtil(options,function(data){
                  _this.banklist=data.list;

              })
            },
            getBack:function(){
              this.$router.go(-1);
            },
            PasWord: function () {
                let options = {
                    'Service': "nethos.system.atta.upload"
                };
                return upLoadBasicParam.sign
            },
            beforeUpload:function(file){
                let _this=this;
                return new Promise(function (resove, reject) {
                    _this.uploadData = Object.assign({
                        'file': file,
                        'Service': "nethos.system.atta.upload"
                    }, upLoadBasicParam);
                    resove(true);
                });
            },
            beforeUpload1:function(file){
                let _this=this;
                return new Promise(function (resove, reject) {
                    _this.uploadData1 = Object.assign({
                        'file': file,
                        'Service': "nethos.system.atta.upload"
                    }, upLoadBasicParam);
                    resove(true);
                });
            },
            setCard:function(){
                let _this=this;
                let user=JSON.parse(sessionStorage.getItem("loginInfo"))

                _this.attaIdList.push(this.docIdcardA.attId);
                _this.attaIdList.push(this.docIdcardB.attId);
                let options=({
                    bankAccount:_this.bankAccount,
                    bankName:_this.bankName,
                    bankDeposit:_this.bankDeposit,
                    docIdCardUrlA:_this.docIdcardA.attId,
                    docIdCardUrlB:_this.docIdcardB.attId,
                    token: localStorage.getItem("token"),
                    Service:"nethos.doc.bank.update"
                });
                axiosUtil(options, function(data){
                    _this.docIdcardA.url=data.obj.docIdcardUrlA
                    _this.docIdcardB.url=data.obj.docIdcardUrlB
                    const cardA = JSON.parse(localStorage.getItem('docIdcardA'))
                    const cardB = JSON.parse(localStorage.getItem('docIdcardB'))
                    localStorage.setItem('userInfo', JSON.stringify(Object.assign({}, JSON.parse(sessionStorage.getItem("loginInfo")), {
                        bankAccount: _this.bankAccount,
                        bankName: _this.bankName,
                        bankDeposit: _this.bankDeposit,
                    })));
                    localStorage.setItem("docIdcardA",JSON.stringify(Object.assign({}, cardA, { url:  data.obj.docIdcardUrlA})))
                    localStorage.setItem("docIdcardB",JSON.stringify(Object.assign({}, cardB, { url:  data.obj.docIdcardUrlB})))
                    _this.isSuccess = false;
                    Message({
                        showClose: true,
                        message: "提交成功！",
                        type: "success"
                    });
                    _this.$router.go(-1);
                }, function () {//发生错误时也设置为false防止按钮一直再loading状态
                    _this.isSuccess = false;
                });
            },
            onSuccessImg: function(response, file, fileList){//上传图片成功后钩子

                if (response.succ) {
                    this.imgUploadList = fileList;
                    this.imageUrl = response.obj.url;
                    this.docIdcardA.attId= response.obj.attaId;
                    const cardA = JSON.parse(localStorage.getItem('docIdcardA'))
                    localStorage.setItem("docIdcardA", JSON.stringify(Object.assign({}, cardA, {attId: this.docIdcardA.attId})))

                } else {
                    Message({
                        showClose: true,
                        message: response.msg,
                        type: "error"
                    });
                }
            },
            onSuccessImg1: function(response, file, fileList){//上传图片成功后钩子
                if (response.succ) {
                    this.imgUploadList1 = fileList;
                    this.imageUrl1 = response.obj.url
                    this.docIdcardB.attId = response.obj.attaId
                    const cardB = JSON.parse(localStorage.getItem('docIdcardB'))
                    localStorage.setItem("docIdcardB", JSON.stringify(Object.assign({}, cardB, {attId: this.docIdcardB.attId})))
                } else {
                    Message({
                        showClose: true,
                        message: response.msg,
                        type: "error"
                    });
                }
            },
        }
    }
</script>
